import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "../slices/api/authApi";
import { userApi } from "../slices/api/userApi";
import generalReducer from "../slices/generalSlice";
import { projectsApiSlice } from "../slices/api/projectsApiSlice";
import { fundApiSlice } from "../slices/api/fundApiSlice";
import { generalApiSlice } from "../slices/api/generalApiSlice";
import { resultApiSlice } from "../slices/api/resultApiSlice";
import { communityApiSlice } from "../slices/api/communityApiSlice";
import { adminApiSlice } from "../slices/api/adminApiSlice";

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [projectsApiSlice.reducerPath]: projectsApiSlice.reducer,
    [fundApiSlice.reducerPath]: fundApiSlice.reducer,
    [generalApiSlice.reducerPath]: generalApiSlice.reducer,
    [resultApiSlice.reducerPath]: resultApiSlice.reducer,
    [communityApiSlice.reducerPath]: communityApiSlice.reducer,
    [adminApiSlice.reducerPath]: adminApiSlice.reducer,
    general: generalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these paths in the state for serialization checks
        ignoredActions: [
          // Ignore RTK Query actions as they may contain non-serializable data temporarily
          'authApi/executeQuery/fulfilled',
          'authApi/executeMutation/fulfilled',
          'userApi/executeQuery/fulfilled',
          'userApi/executeMutation/fulfilled',
        ],
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        ignoredPaths: [
          // Ignore RTK Query cache state
          'authApi.queries',
          'authApi.mutations',
          'userApi.queries',
          'userApi.mutations',
        ],
      },
    }).concat(
      authApi.middleware,
      userApi.middleware,
      projectsApiSlice.middleware,
      fundApiSlice.middleware,
      generalApiSlice.middleware,
      resultApiSlice.middleware,
      communityApiSlice.middleware,
      adminApiSlice.middleware
    ),
});
